import { render, staticRenderFns } from "./dataSummary.vue?vue&type=template&id=41bf1ed4"
import script from "./dataSummary.vue?vue&type=script&lang=js"
export * from "./dataSummary.vue?vue&type=script&lang=js"
import style0 from "./dataSummary.vue?vue&type=style&index=0&id=41bf1ed4&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports